export const ERROR_MESSAGES = {
  CARD_NUMBER_REQUIRED: 'カード番号を入力してください',
  CARD_NUMBER_INVALID: 'カード番号が正しくありません',
  EXPIRY_REQUIRED: '有効期限を入力してください',
  EXPIRY_MONTH_INVALID: '月は01-12の範囲で入力してください',
  EXPIRY_PAST: '有効期限が過去の日付です',
  CARD_HOLDER_REQUIRED: 'カード名義人を入力してください',
  CARD_HOLDER_INVALID: '半角アルファベットで入力してください',
  SECURITY_CODE_REQUIRED: 'セキュリティコードを入力してください',
  SECURITY_CODE_INVALID: 'セキュリティコードが正しくありません',
}

export const validateCardNumber = (cardNumber) => {
  if (!cardNumber) return ERROR_MESSAGES.CARD_NUMBER_REQUIRED
  if (!/^\d{13,19}$/.test(cardNumber)) return ERROR_MESSAGES.CARD_NUMBER_INVALID
  return null
}

export const validateExpiry = (month, year) => {
  if (!month || !year) return ERROR_MESSAGES.EXPIRY_REQUIRED

  const monthNum = parseInt(month, 10)
  const yearNum = parseInt(year, 10)
  const fullYear = yearNum < 100 ? 2000 + yearNum : yearNum

  if (monthNum < 1 || monthNum > 12) return ERROR_MESSAGES.EXPIRY_MONTH_INVALID

  const now = new Date()
  // 有効期限は月末まで有効とする
  const expiryDate = new Date(fullYear, monthNum, 0, 23, 59, 59, 999) // 月の最終日 23:59:59.999
  if (expiryDate < now) return ERROR_MESSAGES.EXPIRY_PAST

  return null
}

export const validateCardHolder = (cardHolder) => {
  if (!cardHolder) return ERROR_MESSAGES.CARD_HOLDER_REQUIRED
  if (!/^[A-Za-z\s]+$/.test(cardHolder)) return ERROR_MESSAGES.CARD_HOLDER_INVALID
  return null
}

export const validateSecurityCode = (securityCode) => {
  if (!securityCode) return ERROR_MESSAGES.SECURITY_CODE_REQUIRED
  if (!/^\d{3,4}$/.test(securityCode)) return ERROR_MESSAGES.SECURITY_CODE_INVALID
  return null
}

export const validateCardForm = ({ cardNumber, expiryMonth, expiryYear, cardHolder, securityCode }) => {
  const errors = {}

  const cardNumberError = validateCardNumber(cardNumber)
  if (cardNumberError) errors.cardNumber = cardNumberError

  const expiryError = validateExpiry(expiryMonth, expiryYear)
  if (expiryError) errors.expiry = expiryError

  const cardHolderError = validateCardHolder(cardHolder)
  if (cardHolderError) errors.cardHolder = cardHolderError

  const securityCodeError = validateSecurityCode(securityCode)
  if (securityCodeError) errors.securityCode = securityCodeError

  return {
    isValid: Object.keys(errors).length === 0,
    errors,
  }
}
